// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-collection-dialog__field {
  margin-bottom: 12px;
}
.dl-collection-dialog__field:last-child {
  margin-bottom: 0;
}
.dl-collection-dialog__title {
  margin-bottom: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/CollectionsStructure/CollectionDialog/CollectionDialog.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAEQ;EACI,gBAAA;AAAZ;AAII;EACI,kBAAA;AAFR","sourcesContent":[".dl-collection-dialog__field {\n  margin-bottom: 12px;\n}\n.dl-collection-dialog__field:last-child {\n  margin-bottom: 0;\n}\n.dl-collection-dialog__title {\n  margin-bottom: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
